import { Chip } from "@material-tailwind/react";
import { getStatusColor } from "../lib/formatters";
interface Props {
  orderStatus: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const OrderStatusChip = ({ orderStatus, size = "sm", className= "justify-center" }: Props) => {
  return (
    <Chip
      variant="filled"
      size={size}
      className={className}
      value={orderStatus}
      color={getStatusColor(orderStatus)}
    />
  );
};

export default OrderStatusChip;
